/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";

import { EFeePayee } from "../../../../setup/api/services/contract/models";
import { NO_SHIPMENT_COMPANY } from "../../constants";
import { IContractProps } from "../../models";
import InfoItem from "./infoItem";
import styles from "./styles.module.scss";

const AdditionalDetails = ({ contract }: IContractProps) => {
  const { t } = useTranslation();
  const returnFeePayee = (feePayee: EFeePayee) => {
    return feePayee === EFeePayee.CUSTOMER
      ? t("lbl_customer")
      : t("lbl_contract_details_seller");
  };

  return (
    <div className={styles.info_container}>
      <h4>{t("lbl_additionial_info")}</h4>
      <div className={styles.infoitem_container}>
        <InfoItem
          title={t("lbl_more_details_sheet_shipping_by")}
          value={
            contract?.shipment?.fee
              ? t("lbl_more_contract_details_shipment_company")
              : NO_SHIPMENT_COMPANY
          }
          image="/assets/images/svg/shipmentInfo.svg"
        />
        <div className={styles.infoitem_divider} />
        <InfoItem
          title={t("lbl_more_details_sheet_fees")}
          value={returnFeePayee(contract.feePayee)}
          image="/assets/images/svg/payment.svg"
        />
      </div>
    </div>
  );
};

export default AdditionalDetails;
